import { formatNumber } from "../../utils/format.ts";

export function formatBucketLabel(bucket: string): string {
  if (bucket === "1") return "1 (Self-Employed)";
  if (bucket === "10001+") return `${formatNumber(10001)}+`;
  const match = bucket.match(/^(\d+)-(\d+)$/);
  if (match) {
    return `${formatNumber(Number(match[1]))}-${formatNumber(Number(match[2]))}`;
  }
  return bucket;
}

export function parseIntOrUndefined(value: string): number | undefined {
  if (!value || value === "-") return undefined;
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? undefined : n;
}
